import _LoginService from "../services/login-service";
import { ILoginService } from "../types/services/login-service";

const LoginService: ILoginService = new _LoginService();

export default LoginService;
